import { handleMessage } from "../../utils";
import Properties from "../../../../properties";

const CONTA = {
  conta: {
    login: {
      acesseSuaCarteiraPesca: [
        "Acesse sua Carteira de Pesca",
        "Access your Fishing License"
      ],
      login: ["Login", "Login"],
      cadastrar: ["Cadastre-se", "Register"],
      naoRecebiEmail: [
        "Não recebi o e-mail de confirmação",
        "I didn't receive the confirmation email"
      ],
      esqueciSenha: ["Esqueci minha senha", "I forgot my password"],
      digiteSeuCpfPassaporte: [
        "Digite seu CPF (passport)",
        "Enter your CPF (passport)"
      ],
      digiteSuaSenha: ["Digite sua senha", "Enter your password"],
      labelCpfPassaporte: ["CPF ou passaporte", "CPF or passport"],
      placeholderCpfPassaporte: [
        "Digite seu CPF ou passaporte",
        "Enter your CPF or passport"
      ],
      informesIpaam: {
        titulo: ["Informes do IPAAM", "IPAAM News"],
        descricao: [
          "Fique por dentro das notícias oficiais divulgadas.",
          "Stay informed about official news."
        ]
      },
      guiasManuais: {
        titulo: ["Guias e manuais", "Guides and manuals"],
        descricao: ["Faça o download dos manuais.", "Download the manuals."]
      }
    },
    redefinicaoSenha: {
      modal: {
        titulo: ["Redefinição de senha", "Password reset"],
        descricao: [
          "Informe o <b>CPF</b> ou o <b>passaporte</b> usados no cadastro. Se existir conta vinculada, você receberá um e-mail com um link para definir uma nova senha.",
          "Enter the <b>CPF</b> or the <b>passport</b> used in the registration. If there is a linked account, you will receive an email with a link to define a new password."
        ],
        sucesso: [
          "Um e-mail com um link para redefinir sua senha foi enviado para o seu endereço de e-mail.",
          "An email with a link to reset your password has been sent to your email address."
        ],
        error: [
          "Não foi possível enviar o e-mail de redefinição de senha. Tente novamente mais tarde ou entre em contato com o suporte.",
          "Could not send the password reset email. Please try again later or contact support."
        ]
      }
    },
    emailConfirmacao: {
      modal: {
        titulo: ["Confirmação de e-mail", "Email confirmation"],
        descricao: [
          "Informe o <b>CPF</b> ou o <b>passaporte</b> usados no cadastro. Se existir conta vinculada, você receberá um e-mail com um link para ativar sua conta.",
          "Enter the <b>CPF</b> or the <b>passport</b> used in the registration. If there is a linked account, you will receive an email with a link to activate your account."
        ],
        sucesso: [
          "Um e-mail com um link para ativar sua conta foi enviado para o seu endereço de e-mail.",
          "An email with a link to activate your account has been sent to your email address."
        ],
        error: [
          "Não foi possível enviar o e-mail de confirmação. Tente novamente mais tarde ou entre em contato com o suporte.",
          "Could not send the confirmation email. Please try again later or contact support."
        ]
      }
    },
    envioEmail: {
      sucesso: [
        "Se os dados informados estiverem corretos, você receberá um e-mail com as instruções em instantes.",
        "If the information provided is correct, you will receive an email with the instructions in a few moments."
      ]
    },
    verificarEmail: {
      verificando: ["Confirmando seu e-mail…", "Confirming your email…"],
      sucessoTitulo: ["E-mail confirmado", "Email confirmed"],
      sucessoDescricao: [
        "Sua conta foi ativada. Você já pode acessar o sistema com seu CPF ou passaporte e senha.",
        "Your account has been activated. You can now sign in with your CPF or passport and password."
      ],
      erroTitulo: [
        "Não foi possível confirmar o e-mail",
        "Could not confirm your email"
      ],
      erroDescricao: [
        "O link é inválido, já foi utilizado ou expirou. Solicite um novo e-mail de confirmação na tela de login.",
        "The link is invalid, already used, or expired. Request a new confirmation email on the login screen."
      ],
      tokenAusente: [
        "Link de confirmação incompleto. Verifique o endereço no e-mail ou solicite um novo envio.",
        "Incomplete confirmation link. Check the address in your email or request a new one."
      ],
      irLogin: ["Ir para o login", "Go to login"],
      irLoginComContagem: ["Ir para o login ({0}s)", "Go to login ({0}s)"],
      redirecionamentoEm: [
        "Ou aguarde: redirecionamento automático em {0} segundos.",
        "Or wait: automatic redirect in {0} seconds."
      ]
    },
    redefinirSenha: {
      titulo: ["Redefinir senha", "Reset password"],
      descricao: [
        "Defina uma nova senha para acessar a Carteira de Pesca.",
        "Set a new password to access the Fishing License system."
      ],
      labelSenha: ["Nova senha", "New password"],
      labelConfirmarSenha: ["Confirmar nova senha", "Confirm new password"],
      placeholderSenha: ["Digite sua senha", "Enter your password"],
      placeholderConfirmarSenha: [
        "Digite a senha novamente",
        "Enter your password again"
      ],
      botaoSalvar: ["Salvar nova senha", "Save new password"],
      salvando: ["Salvando nova senha…", "Saving new password…"],
      sucessoTitulo: ["Senha alterada", "Password changed"],
      sucessoDescricao: [
        "Sua senha foi redefinida. Você já pode acessar o sistema com a nova senha.",
        "Your password has been reset. You can now sign in with your new password."
      ],
      erroTitulo: [
        "Não foi possível redefinir a senha",
        "Could not reset your password"
      ],
      erroDescricao: [
        "O link é inválido, já foi utilizado ou expirou. Solicite um novo e-mail de redefinição na tela de login.",
        "The link is invalid, already used, or expired. Request a new reset email on the login screen."
      ],
      tokenAusente: [
        "Link de redefinição incompleto. Verifique o endereço no e-mail ou solicite um novo envio.",
        "Incomplete reset link. Check the address in your email or request a new one."
      ],
      irLogin: ["Ir para o login", "Go to login"],
      irLoginComContagem: ["Ir para o login ({0}s)", "Go to login ({0}s)"],
      redirecionamentoEm: [
        "Ou aguarde: redirecionamento automático em {0} segundos.",
        "Or wait: automatic redirect in {0} seconds."
      ]
    }
  }
};

export const PT_CONTA = handleMessage(CONTA, Properties.LANGUAGE_INDEX.PT_BR);
export const EN_CONTA = handleMessage(CONTA, Properties.LANGUAGE_INDEX.EN);
